import React from 'react';
import {createSvgIcon} from '@mui/material/utils';

const PtrnExcelIcon = createSvgIcon(
   <>
      {/* File silhouette (similar to InsertDriveFile) */}
      <path
         fill="currentColor"
         d="M6 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 
         2-.9 2-2V8l-6-6H6zm7 1.5V9h5.5L13 3.5z"
      />
      {/* Green “X” symbol */}
      <path
         fill="#2E7D32"
         d="M8 11h2l1 1 1-1h2l-2 2 2 2h-2l-1-1-1 1H8l2-2z"
         transform="translate(-9, -8) scale(1.8)"
      />
   </>,
   'PtrnExcelIcon'
);

export default PtrnExcelIcon;
